export default "__VITE_ASSET__CydtRlrG__"